<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">
    <table v-if='sampleDraft' class='draftTable' ref='drawdown-table'>
        <tr>
            <!-- warp thread colors -->
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><colors-array uniqueCanvasId='warpColorsArray' :rowsCount='1' :columnsCount='sampleDraft.WarpThreadsCount' :itemsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' :colorsArray='warpThreads' :renderingKey='threadsRenderingKey' :isSearchAndReplace='false' :isCopy='false' :isPaste='false' /></td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'/>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
        </tr>
        <tr>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'><ruler :itemsCount='sampleDraft.WarpThreadsCount' startingSide='right' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, false, false)'><ruler :itemsCount='sampleDraft.TreadlesCount' startingSide='left' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'/>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'/>
        </tr>
        <tr>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'>
                <!-- threading -->
                <grid uniqueCanvasId='threadingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="threading" :singleColumnSelection='false' :singleRowSelection='true' :isReadOnly='!allowDraftEdits' :showInverse='false' :renderingKey='drawdownRenderingKey'/>
            </td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'>
                <!-- tieup -->
                <grid uniqueCanvasId='tieupGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.TreadlesCount' :cellPixelSize='cellPixelSize'  :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="tieup"  :singleColumnSelection='false' :singleRowSelection='false' :isReadOnly='!allowDraftEdits' :showInverse='showReverse' :renderingKey='drawdownRenderingKey'/>
            </td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
        </tr>
        <tr>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'>
                <!-- drawdown -->
                <drawdown-grid :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels="1" :warpThreads = 'warpThreads' :weftThreads = 'weftThreads' :groundWeaveWeftThreads = '[]' :drawdownArray = 'drawdown' :showDividingLines='showLines' :renderingKey='drawdownRenderingKey + showLines + showReverse' :warpColorTransparency='1.0' :weftColorTransparency='1.0' :groundWeaveDrawdownArray='[]' :showReverseSide='showReverse'/>                        
            </td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'>
                <!-- treadling -->
                <grid uniqueCanvasId='treadlingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='sampleDraft.TreadlesCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="treadling" :singleColumnSelection='true' :singleRowSelection='false' :isReadOnly='!allowDraftEdits' :showInverse='false' :renderingKey='drawdownRenderingKey'/>
            </td>
            <!-- weft thread colors -->
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><ruler :itemsCount='sampleDraft.WeftThreadsCount' startingSide='top' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
            <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><colors-array uniqueCanvasId='weftColorsArray' :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='1' :itemsCount='sampleDraft.WeftThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' :colorsArray='weftThreads' :renderingKey='threadsRenderingKey' :isSearchAndReplace='false' :isCopy='false' :isPaste='false' /></td>
        </tr>                
    </table>
    </b-container>
</template>

<script>

import utilityService from '../mixins/utilityService.js'
import draftEditorService from '../mixins/draftEditorService.js'
import ruler from './Ruler.vue'
import grid from './Grid.vue'
import colorsArray from './ColorsArray.vue'
import drawdownGrid from './DrawdownGrid.vue'

export default {
    props: {
        sampleDraftJSON: {
            type: Object,
            required: false
        },
        cellPixelSize: {
            type: Number,
            required: true
        },
        showLines: {
            type: Boolean,
            required: true
        },
        showReverse: {
            type: Boolean,
            required: true
        }
    },
    mixins: [utilityService, draftEditorService],
    data: function() {
        return {
            sampleDraft: null,
            threading: null,
            tieup: null,
            treadling: null,
            warpColors: null,
            weftColors: null,
            drawdown: null,
            allWeftThreadNumbers: null,
            allWarpThreadNumbers: null,
            gridBorderColor: '#acacac',
            borderThicknessPixels: 1,
            threadsRenderingKey: '777',
            allowDraftEdits: false,
            threadingHash: 0
        }
    },
    methods: {
        initializeComponent() {
            // load all of the draft's current weft and warp thread numbers
            if (this.sampleDraftJSON && this.sampleDraftJSON.length > 0) {
                this.sampleDraft = JSON.parse(this.sampleDraftJSON)
            }
            if (this.sampleDraft) {
                this.allWeftThreadNumbers = []

                for (let w=0; w < this.sampleDraft.WeftThreadsCount; w++) {
                    this.allWeftThreadNumbers.push(w)
                }
                this.allWarpThreadNumbers = []
                for (let w=0; w < this.sampleDraft.WarpThreadsCount; w++) {
                    this.allWarpThreadNumbers.push(w)
                }

                // load arrays from draft JSON
                this.tieup = new Array(this.sampleDraft.ShaftsCount)
                this.threading = new Array(this.sampleDraft.ShaftsCount)
                this.treadling = new Array(this.sampleDraft.WeftThreadsCount)
                this.warpThreads = new Array(this.sampleDraft.WarpThreadsCount)
                this.weftThreads = new Array(this.sampleDraft.WeftThreadsCount)
                this.loadArraysFromDraftJSON(this.tieup, this.threading, this.treadling, this.warpThreads, this.weftThreads, this.sampleDraft)

                this.drawdown = this.initializeDrawdownArray(this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount)

                // determine whether or not the draft is overshot
                this.overshotTabbyTreadleNumbers = this.getOvershotTreadleNumbers(this.tieup, this.treadling)
                this.isOvershotPattern = (this.overshotTabbyTreadleNumbers.length > 0)
                // console.log('overshotTabbyTreadleNumbers: ' + JSON.stringify(this.overshotTabbyTreadleNumbers))

                // causes threads to rerender when the same WIF file is loaded twice and no other parameter for ColorsArray changes to otherwise cause this
                this.threadsRenderingKey = this.uuidv4()

                this.loadDrawdown(this.sampleDraft.ShaftsCount, this.sampleDraft.TreadlesCount, this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount, this.allWarpThreadNumbers, this.allWeftThreadNumbers, this.drawdown, this.treadling, this.threading, this.tieup, this.showReverse)
                this.drawdownRenderingKey = this.uuidv4()
            }
        }

    },
    components: {
        grid: grid,
        colorsArray: colorsArray,
        drawdownGrid: drawdownGrid,
        ruler: ruler
    },
    watch: {
    },
    computed: {
    },
    created() {
        console.log('in dro created')
        this.initializeComponent()
    },
    updated() {
        console.log('in dro updated')
        this.initializeComponent()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DraftReadOnly.vue